import React from 'react';
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PersonIcon from '@mui/icons-material/Person';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import MapIcon from '@mui/icons-material/Map';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function TabNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const pathname = location.pathname || '';
  const current = (() => {
    if (pathname.startsWith('/profile')) return 'profile';
    // Check catch-map before catch so /catch-map doesn't match /catch
    if (pathname.startsWith('/catch-map')) return 'catchmap';
    if (pathname.startsWith('/catch')) return 'catch';
    if (pathname.startsWith('/buddies')) return 'buddies';
    return 'dashboard';
  })();

  const handleChange = (_e, value) => {
    switch (value) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'buddies':
        navigate('/buddies');
        break;
      case 'catch':
        // Open dashboard with Add Catch dialog and camera pre-opened
        navigate('/dashboard', { state: { openCatchDialog: true, openCamera: true } });
        break;
      case 'catchmap':
        navigate('/catch-map');
        break;
      case 'profile':
        if (user?.id) navigate(`/profile/${user.id}`);
        break;
      default:
        break;
    }
  };

  return (
    <Paper
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      // Keep nav above page content but below drawers/dialogs
      zIndex: (theme) => theme.zIndex.appBar,
    }}
      elevation={8}
    >
      <BottomNavigation value={current} onChange={handleChange} showLabels>
        <BottomNavigationAction value="dashboard" label="Dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction value="buddies" label="Buddies" icon={<PeopleAltIcon />} />
        <BottomNavigationAction
          value="catch"
          label="Add Catch"
          icon={<AddCircleIcon sx={{ fontSize: 40 }} />}
          sx={{
            mt: -1,
            color: 'primary.main',
            '& .MuiBottomNavigationAction-label': {
              fontWeight: 'bold',
            },
          }}
        />
        <BottomNavigationAction value="catchmap" label="Catch Map" icon={<MapIcon />} />
        <BottomNavigationAction value="profile" label="Profile" icon={<PersonIcon />} disabled={!user?.id} />
      </BottomNavigation>
    </Paper>
  );
}
